import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import RejectPopupModal from "./rejectPopupModal";
import { cretateTestMemoDetails } from "./commonHandlerFunction/testMemoFunctionHandler";
import { encryptDataForURL } from "../../utills/useCryptoUtils";
import {
  GetTenantDetails,
  postDataFromApi,
} from "../../services/commonServices";
import {
  getCurrentRole,
  getOperationActivityListPageUrl,
  getOperationActivityUrl,
  getPurchaseManager,
  getUserDetails,
  isModuelePermission,
  SagarAuditUserRole,
} from "../../services/commonFunction";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { handleFormSave } from "./commonHandlerFunction/JRFHandlerFunctions";
import {
  handleGetJobCostingList,
  handleJobCostingFormCreateAndUpdate,
} from "./commonHandlerFunction/Audit/JobCosting/JobCostingHandlerFunction";
import { getSingleBranchExpense } from "./commonHandlerFunction/Audit/BranchExpenseHandler";
import { handleGetSingleOutstanding } from "./commonHandlerFunction/Audit/OutStanding/OutStandingHandlerFunction";
import { handleGetSingleSalesRegister } from "./commonHandlerFunction/Audit/SalesRegister/SalesRegisterHandlerFunction";
import {
  handleDownloadPO,
  handlePurchaseOrderCreateUpdate,
} from "./commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";
import { handlePurchaseReqUpdateCreate } from "./commonHandlerFunction/Purchase/PurchaseReq/PurchaseRequsitionHandler";
import { handleCreateDebitFromList } from "./commonHandlerFunction/InvoiceHandlerFunctions";
import { historyData } from "../../actions/authActions";
import {
  InternalCertificateGetPDFApi,
  testMemoPDFDownloadApi,
  allotmentCancelApi,
  JRFGetPDFApi,
} from "../../services/api";
import { checkNextApproval } from "./commonHandlerFunction/Collections/CreditNoteHandler";
import ConfirmationModal from "./ConfirmationModal";
const ListingActionButton = ({
  status,
  actions,
  user,
  moduleType,
  jrf_id,
  sampleInwardFormId,
  row,
  setIsRejectPopupOpen,
  setJRFCreationType,
  setIsPopupOpen,
  setIsOverlayLoader,
  handleSubmit,
  setFormData,
  formData,
  setSubTableData,
  setIsCustomPopup,
  setCurrentActiverow,
  formConfig,
  getAllListingData,
  setResponse,
  responseData,
  rowIndex,
  subModuleType,
  setIsSubListPopupOpen,
  setSelectedItems,
}) => {
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCancelRemarkOpen, setIsCancelRemarkOpen] = useState(false);
  const [cancelRemark, setCancelRemark] = useState("");
  const [cancelSaId, setCancelSaId] = useState(null);
  const [isShowMessagePopup, setIsShowMessagePopup] = useState(false);
  const [showMessageDescription, setShowMessageDescription] = useState(null);
  let rolePermissions;
  rolePermissions = user?.permissions;
  const actionBtnList = {
    jrf: [
      {
        btnStatus: "posted",
        label: "Verify Checklist",
        status: "checklist",
        btnshortName: "verifyCheckList",
      },
      {
        btnStatus: "accepted",
        label: "Sample Inward",
        status: "inward",
        btnshortName: "sampleInward",
      },
      {
        btnStatus: "completed",
        label: "Test Report",
        status: "testReport",
        btnshortName: "testReport",
      },
      {
        btnStatus: "rejected",
        label: "Update",
        status: "rejected",
        btnshortName: "Edit",
      },
      {
        btnStatus: "saved",
        label: "Update",
        status: "saved",
        btnshortName: "Saved",
      },
      {
        btnStatus: "completed",
        label: "Re-Generate",
        status: "regenrateBtn",
        btnshortName: "regenrateBtn",
        isRegenerateBtn: true,
      }
    ],
    sampleinward: [
      {
        btnStatus: "inwarded",
        label: "Assignment",
        status: "assignment",
        btnshortName: "assignment",
      },
      {
        btnStatus: "assigning",
        label: "Assignment",
        status: "assignment",
        btnshortName: "assignment",
      },
      {
        btnStatus: "created",
        label: "Sample Inward",
        status: "inward",
        btnshortName: "sampleInward",
      },
      {
        btnStatus: "saved",
        label: "Sample Inward",
        status: "inward",
        btnshortName: "sampleInward",
      },
      {
        btnStatus: "assigned",
        label: "Create Test Memo",
        status: "testMemo",
        btnshortName: "testMemo",
      },
      {
        btnStatus: "certified",
        label: "Test Report",
        status: "certified",
        btnshortName: "testReport",
      },
    ],
    allotment: [
      {
        btnStatus: "pending",
        label: "Allot",
        status: "allot",
        btnshortName: "allot",
      },
      {
        btnStatus: "allotted",
        label: "Update",
        status: "allotted",
        btnshortName: "Edit",
      },
      {
        btnStatus: "allotted",
        label: "Verification",
        status: "verification",
        btnshortName: "verification",
      },
      {
        btnStatus: "pending",
        label: "Cancel",
        status: "cancel",
        btnshortName: "cancel",
      },
    ],
    testmemomain: [
      {
        btnStatus: "pending",
        label: "Verify Test Memo",
        status: "pending",
        btnshortName: "verifytestmemo",
      },
      {
        btnStatus: "posted",
        label: "Allot",
        status: "posted",
        btnshortName: "create-allot",
      },
      {
        btnStatus: "created",
        label: "Send to Lab",
        status: "sendToLab",
        btnshortName: "sendToLab",
      },
      {
        btnStatus: "results",
        label: "Verify Test Result",
        status: "results",
        btnshortName: "verifytestresult",
      },
      {
        btnStatus: "verified",
        label: "Test Report",
        status: "verified",
        btnshortName: "testmemoresult",
      },
      {
        btnStatus: "rejected",
        label: "Update",
        status: "rejected",
        btnshortName: "Edit",
      },
      {
        btnStatus: "certified",
        label: "Re-Generate",
        status: "regenrateBtn",
        btnshortName: "regenrateBtn",
        isRegenerateBtn: true,
      },
    ],
    sampleverification: [
      {
        btnStatus: "pending",
        label: "Verification",
        status: "verification",
        btnshortName: "verification",
      },
    ],
    sfm: [
      {
        btnStatus: "pending",
        label: "Result",
        status: "SFMResult",
        btnshortName: "SFMResult",
      },
      {
        btnStatus: "in-process",
        label: "Result",
        status: "SFMResult",
        btnshortName: "SFMResult",
      },
      {
        btnStatus: "rejected",
        label: "Update",
        status: "SFMUpdate",
        btnshortName: "SFMUpdate",
      },
      {
        btnStatus: "completed",
        label: "Re-Generate",
        status: "regenrateBtn",
        btnshortName: "regenrateBtn",
        isRegenerateBtn: true,
      },
    ],
    internalcertificate: [
      {
        btnStatus: "dtm-approved",
        label: "Verify",
        status: "verifyByTm",
        btnshortName: "verifyByTm",
      },
      {
        btnStatus: "pending",
        label: "Verify",
        status: "verifyByDTM",
        btnshortName: "verifyByDTM",
      },
      {
        btnStatus: "tm-approved",
        label: "Publish",
        status: "publishBtn",
        btnshortName: "publishBtn",
      },
      {
        btnStatus: "dtm-reject",
        label: "Update",
        status: "dtmReject",
        btnshortName: "dtmReject",
      },
      {
        btnStatus: "tm-reject",
        label: "Update",
        status: "tmReject",
        btnshortName: "tmReject",
      },
      {
        btnStatus: "publish",
        label: "Re-Generate",
        status: "regenrateBtn",
        btnshortName: "regenrateBtn",
        isRegenerateBtn: true,
      },
    ],
    jobinstruction: [
      {
        btnStatus: "saved",
        label: "Scope Of Work",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "created",
        label: "Analysis",
        status: "created",
        btnshortName: "created",
      },
      {
        btnStatus: "pre-analysis",
        label: "Analysis",
        status: "pre-analysis",
        btnshortName: "pre-analysis",
      },
      {
        btnStatus: "analysis",
        label: "Nominate",
        status: "analysis",
        btnshortName: "analysis",
      },
      {
        btnStatus: "rejected",
        label: "Update",
        status: "rejected",
        btnshortName: "rejected",
      },
      {
        btnStatus: "posted",
        label: "Verify",
        status: "posted",
        btnshortName: "posted",
      },
      {
        btnStatus: "accepted",
        label: "Process",
        status: "accepted",
        btnshortName: "accepted",
      },
    ],
    jioperationjsonb: [
      {
        btnStatus: "posted",
        label: "Verify",
        status: "posted",
        btnshortName: "posted",
      },
      {
        btnStatus: "accepted",
        label: "Process",
        status: "accepted",
        btnshortName: "accepted",
      },
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
    ],
    TPIMain: [
      {
        btnStatus: "created",
        label: "Update",
        status: "created",
        btnshortName: "created",
      },
      {
        btnStatus: "posted",
        label: "Update",
        status: "posted",
        btnshortName: "posted",
      },
      {
        btnStatus: "completed",
        label: "Update",
        status: "completed",
        btnshortName: "completed",
      },
    ],
    consortiumorder: [
      {
        btnStatus: "saved",
        label: "Consortium Job",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "View JI",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    jobCosting: [
      {
        btnStatus: "updated",
        label: "Edit",
        status: "updated",
        btnshortName: "updated",
      },
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "rejected",
        label: "Edit",
        status: "rejected",
        btnshortName: "rejected",
      },
      {
        btnStatus: "cancelled",
        label: "Comment",
        status: "cancelled",
        btnshortName: "cancelled",
      },
      {
        btnStatus: "posted",
        label: "Send For Approval",
        status: "posted",
        btnshortName: "posted",
      },
      {
        btnStatus: "sent_for_approval",
        label: "Approve",
        status: "sent_for_approval",
        btnshortName: "sent_for_approval",
      }
    ],
    auditBranchExpenses: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
    ],
    auditOutstanding: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
    ],
    auditSalesRegister: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
    ],
    auditBranchSales: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
    ],
    invoice: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "invoice_generated",
        label: "View Invoice",
        status: "invoice_generated",
        btnshortName: "invoice_generated",
      },
      {
        btnStatus: "debit_save",
        label: "Edit Debit Note",
        status: "debit_save",
        btnshortName: "debit_save",
      },
      {
        btnStatus: "invoice_generated",
        label: "Approve",
        status: "invoice_generated",
        btnshortName: "invoice_generated",
      },
    ],
    purchase: [
      {
        btnStatus: "Received",
        label: "Create P.O",
        status: "Received",
        btnshortName: "Received",
      },
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Approve",
        status: "posted",
        btnshortName: "posted",
      },
      {
        btnStatus: "Pre-Close",
        label: "DownLoad",
        status: "Pre-Close",
        btnshortName: "Pre-Close",
      },
      {
        btnStatus: "Closed",
        label: "Download",
        status: "Closed",
        btnshortName: "Closed",
      },
      {
        btnStatus: "Approved",
        label: "PO Received",
        status: "Approved",
        btnshortName: "Approved",
      },
      {
        btnStatus: "Partial",
        label: "PO Received",
        status: "Partial",
        btnshortName: "Partial",
      },
      {
        btnStatus: "Reject",
        label: "Update",
        status: "Reject",
        btnshortName: "Reject",
      },
    ],
    purchaseReq: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Send for Approval",
        status: "posted",
        btnshortName: "posted",
      },
      {
        btnStatus: "sent for approval",
        label: "Approve",
        status: "sent for approval",
        btnshortName: "sent for approval",
      },
      {
        btnStatus: "reject",
        label: "Update",
        status: "reject",
        btnshortName: "reject",
      },
      {
        btnStatus: "approved",
        label: "PO Received",
        status: "approved",
        btnshortName: "approved",
      },
      {
        btnStatus: "approved",
        label: "Create PO",
        status: "approved",
        btnshortName: "approved",
      },
    ],

    amc: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "Posted",
        label: "Edit",
        status: "Posted",
        btnshortName: "Posted",
      },
    ],
    calibration: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    supplier: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    purchaseItems: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    departmentmasterList: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    branchmasterList: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    category: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    tender: [
      {
        btnStatus: "awarded",
        status: "awarded",
        btnshortName: "awarded",
      },
      {
        btnStatus: "not awarded",
        status: "not awarded",
        btnshortName: "not awarded",
      },
      {
        btnStatus: "submitted",
        status: "submitted",
        btnshortName: "submitted",
      },
    ],
    tranferstocks: [
      {
        btnStatus: "pending",
        label: "Edit",
        status: "pending",
        btnshortName: "pending",
      }
    ],
    stocks: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "posted",
        label: "Edit",
        status: "posted",
        btnshortName: "posted",
      },
    ],
    incentives: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
    ],
    creditNoteModule: [
      {
        btnStatus: "saved",
        label: "Edit",
        status: "saved",
        btnshortName: "saved",
      },
      {
        btnStatus: "Completed",
        label: "Edit",
        status: "Completed",
        btnshortName: "Completed",
      },
      {
        btnStatus: "rejected",
        label: "Edit",
        status: "rejected",
        btnshortName: "rejected",
      },
      {
        btnStatus: "tally-created",
        label: "Edit",
        status: "tally-created",
        btnshortName: "tally-created",
      },
    ],
  };

  let rolesWiseBtnList = {
    jrf: {
      BU: ["testReport", "Edit", "Saved"],
      LR: ["testReport", "verifyCheckList", "sampleInward", "Edit", "Saved"],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: [],
      LC: [],
      DTM: [],
      SU: ["regenrateBtn"],
      SA: [],
    },
    sampleinward: {
      BU: ["testReport"],
      LR: ["assignment", "testMemo", "testReport", "sendToLab", "sampleInward"],
      TM: ["verifytestmemo"],
      STM: ["verifytestmemo"],
      QM: ["verifytestmemo"],
      SQM: ["verifytestmemo"],
      SLC: ["verifytestmemo"],
      LC: [],
      DTM: [],
      SU: [],
      SA: [],
    },
    allotment: {
      BU: ["testReport", "cancel"],
      LR: ["assignment", "testMemo", "certified", "cancel"],
      TM: ["verifytestmemo", "Edit", "cancel"],
      STM: ["verifytestmemo", "Edit", "cancel"],
      QM: ["verifytestmemo", "Edit", "cancel"],
      SQM: ["verifytestmemo", "Edit", "cancel"],
      SLC: ["verifytestmemo", "verification", "cancel"],
      LC: ["verification", "cancel"],
      DTM: ["verifytestmemo", "verification", "cancel"],
      SU: ["cancel"],
      SA: ["cancel"],
    },
    sampleverification: {
      BU: [],
      LR: [],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: ["verification"],
      LC: ["verification"],
      DTM: ["verification"],
      SU: [],
      SA: [],
    },
    testmemomain: {
      BU: [],
      LR: ["sendToLab", "testmemoresult", "Edit"],
      TM: ["verifytestmemo", "create-allot", "verifytestresult"],
      STM: ["verifytestmemo", "create-allot", "verifytestresult"],
      QM: ["verifytestmemo", "create-allot", "verifytestresult"],
      SQM: ["verifytestmemo", "create-allot", "verifytestresult"],
      SLC: ["verifytestmemo", "verifytestresult"],
      LC: ["verification"],
      DTM: ["create-allot"],
      SU: ["regenrateBtn"],
      SA: [],
    },
    sfm: {
      BU: [],
      LR: [],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: ["SFMResult", "SFMUpdate"],
      LC: ["SFMResult", "SFMUpdate"],
      DTM: ["SFMResult", "SFMUpdate"],
      SU: ["regenrateBtn"],
      SA: [],
    },
    internalcertificate: {
      BU: [],
      LR: ["publishBtn", "dtmReject", "tmReject"],
      TM: ["verifyByTm", "verifyByDTM"],
      STM: ["verifyByTm"],
      QM: ["verifyByTm"],
      SQM: ["verifyByTm"],
      SLC: ["verifyByDTM"],
      LC: [],
      DTM: ["verifyByDTM"],
      SU: ["regenrateBtn"],
      SA: [],
    },
    jobinstruction: {
      BU: ["posted", "accepted", "process"],
      LR: [],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: [],
      LC: [],
      DTM: [],
      OPS_ADMIN: [
        "saved",
        "created",
        "analysis",
        "pre-analysis",
        "rejected",
        "accepted",
      ],
      SU: ["accepted"],
      BH: ["accepted"],
      CP: [],
      SA: ["accepted"],
      CCPA: ["accepted"],
    },
    jioperationjsonb: {
      BU: ["posted", "accepted", "process", "saved"],
      LR: [],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: [],
      LC: [],
      DTM: [],
      OPS_ADMIN: ["saved", "accepted"],
      SU: ["accepted"],
      BH: ["accepted"],
      CP: [],
      SA: ["accepted"],
      CCPA: ["accepted"],
    },
    TPIMain: {
      BU: ["created", "posted"],
      LR: [],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: [],
      LC: [],
      DTM: [],
      OPS_ADMIN: [],
      SU: [],
      SA: [],
    },
    consortiumorder: {
      BU: ["saved", "posted"],
      LR: [],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: [],
      LC: [],
      DTM: [],
      OPS_ADMIN: ["saved", "posted"],
      SU: ["posted"],
      SA: [],
    },
    jobCosting: {
      BA: ["updated", "saved", "cancelled", "rejected"],
      AUDIT: ["sent_for_approval"],
      BH: ["sent_for_approval"],
    },
    auditBranchExpenses: {
      AUDIT: ["updated", "saved"],
      BU: ["updated", "saved"],
      OPS_ADMIN: ["updated", "saved"]
    },
    auditBranchSales: {
      AUDIT: ["saved"],
    },
    auditOutstanding: {
      AUDIT: ["updated", "saved"],
      BU: ["updated", "saved"],
      OPS_ADMIN: ["updated", "saved"],
      AUDIT: ["updated", "saved"],
    },
    auditSalesRegister: {
      AUDIT: ["updated", "saved"],
      BU: ["updated", "saved"],
      OPS_ADMIN: ["updated", "saved"],
      AUDIT: ["updated", "saved"],
    },
    purchase: {
      PM: [
        "Received",
        "published",
        "saved",
        "posted",
        "Approved",
        "Pre-Close",
        "Closed",
        "Reject",
        "Partial"
      ],
      SU: ["posted", "Pre-Close", "Closed"],
      BH: [
        "posted",
        "Received",
        "published",
        "saved",
        "Approved",
        "Pre-Close",
        "Closed",
        "Reject",
      ],
      AUDIT: ["posted", "Pre-Close", "Closed"],
    },
    purchaseReq: {
      PM: ["sent for Approval", "saved", "posted", "reject", "approved"],
      SU: ["sent for Approval"],
      BH: ["sent for Approval", "saved", "posted", "reject"],
      AUDIT: ["sent for Approval"],
    },
    supplier: {
      PM: ["saved", "posted"],
    },
    purchaseItems: {
      PM: ["saved", "posted"],
    },
    departmentmasterList: {
      PM: ["saved", "posted"],
    },
    branchmasterList: {
      PM: ["saved", "posted"],
    },
    category: {
      PM: ["saved", "posted"],
    },
    invoice: {
      BU: ["saved", "invoice_generated", "debit_save"],
      LR: ["saved", "invoice_generated", "debit_save"],
      TM: [],
      STM: [],
      QM: [],
      SQM: [],
      SLC: [],
      LC: [],
      DTM: [],
      OPS_ADMIN: ["invoice_generated", "debit_save"],
      SU: ["invoice_generated", "debit_save"],
      CU: ["invoice_generated", "debit_save"],
      BH: ["invoice_generated", "debit_save"],
    },
    AUDIT: {
      BU: ["updated", "saved"],
    },
    calibration: {
      PM: ["saved", "posted"],
    },
    amc: {
      PM: ["saved", "Posted"],
      SU: ["saved", "Posted"]
    },
    tranferstocks: {
      PM: ["pending"]
    },
    stocks: {
      PM: ["saved"],//"posted" removed from stocks module as mail point edit option removed after posted
      BH: ["saved"],
      BU: ["saved"],
      SLC: ["saved"],
      LC: ["saved"],
      DTM: ["saved"],
    },
    incentives: {
      PM: ["saved"],
      BU: ["saved"],
      BH: ["saved"],
    },
    creditNoteModule: {
      LR: ["saved", "Completed"],
      BU: ["saved", "Completed"],
      CU: ["Completed", "tally-created"]
    },
  };

  const getBtnListArray = () => {
    let btnFilteredData = [];
    btnFilteredData = actionBtnList[moduleType]?.filter((btn) => {
      if (
        GetTenantDetails(1, 1) === "TPBPL" &&
        moduleType === "allotment" &&
        ["LC", "SLC", "DTM"].includes(user?.role)
      ) {
        return false;
      }
      if (['purchaseReq', 'purchase', 'supplier', 'calibration', 'stock', 'purchaseItems', 'category', 'branchmasterList', 'departmentmasterList', 'stocks'].includes(moduleType)) {
        if (!['SA'].includes(user?.role)) {
          const permissionMap = {
            purchaseReq: 'purchaserequisition',
            purchase: 'purchaseorder'
          };

          const permissionType = permissionMap[moduleType];
          const hasPermission = !permissionType || isModuelePermission(rolePermissions, permissionType, "change");

          if (hasPermission) {
            rolesWiseBtnList[moduleType][user?.role] = rolesWiseBtnList[moduleType]?.['PM'];
          }
        }
      }
      else if (['jobCosting', 'auditBranchExpenses', 'auditSalesRegister'].includes(moduleType)) {
        if (user?.logged_in_user_info?.usr_is_branch_audit || ['CCPA'].includes(user?.role)) {
          rolesWiseBtnList[moduleType][user?.role] = rolesWiseBtnList[moduleType]?.['BA'];
        }
      }
      if (["incentives"].includes(moduleType)) {
        if (!["SA",'CCPA'].includes(user?.role))
          rolesWiseBtnList[moduleType][user?.role] =
            rolesWiseBtnList[moduleType]?.["BU"];
      }
      return (
        (rolesWiseBtnList[moduleType]?.[user?.role] &&
          rolesWiseBtnList[moduleType]?.[user?.role]
            .map((singlestatus) => singlestatus.toLowerCase())
            .includes(btn.btnshortName.toLowerCase())) ||
        false
      );
    });
    return btnFilteredData;
  };

  const handleAllotmentCancel = async (saId, remark) => {
    try {
      let res = await postDataFromApi(allotmentCancelApi, { sa_id: saId, cancel_remark: remark });
      if (res?.data?.status === 200) {
        toast.success(res.data.message);
        setIsCancelRemarkOpen(false);
        setCancelRemark("");
        setCancelSaId(null);
        getAllListingData();
      } else {
        toast.error(res?.data?.message || "Failed to cancel allotment.");
      }
    } catch (error) {
      toast.error("Failed to cancel allotment.");
    }
  };

  //table Action buttion handler
  const handleOnclick = (action) => {
    if (action.isRegenerateBtn) {
      let endPoint = "";
      let payload = {};
      let fieldName = "";
      switch (moduleType) {
        case "testmemomain":
          payload = {
            test_memo_id: row["tm_id"],
            context: "testmemo",
          };
          endPoint = testMemoPDFDownloadApi;
          fieldName = "tm_is_updated_by_su";
          break;
        case "sfm":
          endPoint = testMemoPDFDownloadApi;
          payload = {
            sfm_id: row["sfm_id"],
            context: "sfm",
          };
          fieldName = "sfm_is_updated_by_su";
          break;
        case "internalcertificate":
          endPoint = InternalCertificateGetPDFApi;
          payload = {
            ic_id: row["ic_id"],
            is_ocr: true
          };
          fieldName = "ic_is_updated_by_su";
          break;
        case "jrf":
          endPoint = JRFGetPDFApi;
          payload = {
            jrf_id: row["jrf_id"],
          };
          fieldName = "jrf_is_updated_by_su";
          break;
        default:
          break;
      }
      handleRegenrateFunc(endPoint, payload, fieldName);
      return;
    }
    if (moduleType === "sampleinward") {
      if (action.status === "testMemo") {
        cretateTestMemoDetails(
          sampleInwardFormId,
          action,
          navigate,
          setIsOverlayLoader,
          setIsShowMessagePopup,
          setShowMessageDescription
        );
      } else if (action?.status == "testReport") {
        // navigate(action?.redirectUrl + "/" + encryptDataForURL(row["internal_certificate_id"]));
        navigate(
          `/testReport/previewPDF/${encryptDataForURL(row["internal_certificate_id"])}` +
          "?ReferenceNo=" +
          encryptDataForURL(row?.jrf_referenceno),
        );
        // handleTestReport(row, action);
      } else {
        navigate(
          action?.redirectUrl +
          "?status=" +
          encryptDataForURL(action?.status) +
          "&sampleInwardId=" +
          encryptDataForURL(sampleInwardFormId) +
          "&id=" +
          encryptDataForURL(jrf_id),
        );
      }
    } else if (moduleType === "allotment") {
      if (action?.status === "cancel") {
        setCancelSaId(row["sa_id"]);
        setIsCancelRemarkOpen(true);
        return;
      }
      navigate(
        action?.redirectUrl +
        "?status=" +
        encryptDataForURL(action?.status) +
        "&sampleAllotmentId=" +
        encryptDataForURL(row["sa_id"]),
      );
    } else if (moduleType === "sampleverification") {
      navigate(
        action?.redirectUrl +
        "?status=" +
        encryptDataForURL(action?.status) +
        "&sampleVarificationId=" +
        encryptDataForURL(row["sv_id"]),
      );
    } else if (moduleType === "testmemomain") {
      if (
        action.status === "create-allot" ||
        action.status === "sendToLab" ||
        action.status === "verifytestmemo"
      ) {
        navigate(
          action?.redirectUrl +
          "?status=" +
          encryptDataForURL(action?.status) +
          "&testMemoId=" +
          encryptDataForURL(row["tm_id"]),
        );
      } else if (action.status == "verifytestresult") {
        navigate(
          action?.redirectUrl +
          "?status=" +
          encryptDataForURL(action?.status) +
          "&testMemoId=" +
          encryptDataForURL(row["tm_id"]),
        );
      } else if (action.status == "testmemoresult") {
        navigate(
          action?.redirectUrl +
          "?status=" +
          encryptDataForURL(action?.status) +
          "&testMemoId=" +
          encryptDataForURL(row["tm_id"]),
        );
      } else if (action.status == "Edit") {
        navigate(
          action?.redirectUrl +
          "?status=" +
          encryptDataForURL(action?.status) +
          "&testMemoId=" +
          encryptDataForURL(row["tm_id"]),
        );
      }
    } else if (moduleType === "sfm") {
      navigate(
        action?.redirectUrl +
        "?status=" +
        encryptDataForURL(action?.status) +
        "&sfmid=" +
        encryptDataForURL(row["sfm_id"]),
      );
    } else if (moduleType === "internalcertificate") {
      localStorage.setItem("icId", encryptDataForURL(row["ic_id"]));
      if (action?.status == "approveByDTM") {
        setIsPopupOpen(true);
        setJRFCreationType("approve");
      } else if (action?.status == "rejectByDTM") {
        setIsRejectPopupOpen(true);
      } else {
        navigate(
          action?.redirectUrl +
          "?status=" +
          encryptDataForURL(action?.status) +
          "&editId=" +
          encryptDataForURL(row["ic_id"]),
        );
      }
    } else if (moduleType == "jobinstruction") {
      if (action.recordType) {
        navigate(
          action?.redirectUrl +
          "/" +
          encryptDataForURL(row["ji_id"]) +
          "/" +
          encryptDataForURL(action.recordType),
        );
      } else if (action.status === "posted") {
        let redirecturl = getOperationActivityListPageUrl(
          row["operation_type"]["operation_type_code"],
        );
        redirecturl = redirecturl.replace(/\/([^\/]*)$/, "-$1");
        navigate(
          redirecturl +
          "view" +
          "/" +
          encryptDataForURL(row["ji_id"]) +
          "?action=" +
          encryptDataForURL("View") +
          "&status=" +
          encryptDataForURL(action?.status) +
          `&isFullDetails=${encryptDataForURL(1)}`,
        );
      } else if (action.status === "accepted") {
        let redirectUrl = getOperationActivityUrl(
          row["operation_type"]["operation_type_name"],
        );
        navigate(
          redirectUrl +
          encryptDataForURL(row["ji_id"]) +
          "?action=" +
          encryptDataForURL("View") +
          "&status=" +
          encryptDataForURL(action?.status) +
          "&operationMode=" +
          encryptDataForURL(row?.["operation_type"]?.operation_type_code),
        );
      } else {
        if (action.status === "rejected") {
          // localStorage.setItem('isMainScopeWork', '')
          dispatch({
            type: "MAIN_SCOPE_WORK",
            isMainScopeWork: "",
          });
          navigate(action?.redirectUrl + "/" + encryptDataForURL(row["ji_id"]));
        } else {
          dispatch({
            type: "MAIN_SCOPE_WORK",
            isMainScopeWork: 1,
          });
          navigate(action?.redirectUrl + "/" + encryptDataForURL(row["ji_id"]));
        }
      }
    } else if (moduleType === "invoice") {
      if (action?.label == "Edit") {
        navigate(
          `/operation/invoice-listing/create-invoice/${encryptDataForURL(
            row["im_id"],
          )}` +
          "?status=" +
          encryptDataForURL("Edit"),
        );
      } else if (action?.value == "View Invoice") {
        navigate(
          `/operation/invoice-listing/invoice-preview/${encryptDataForURL(
            row["im_id"],
          )}/${encryptDataForURL(row["im_invoiceurl"])}/${encryptDataForURL(
            row["im_invoicenumber"],
          )}?invoice_date=${encryptDataForURL(row["im_invoice_date"])}`,
        );
      } else if (action?.label == "View Invoice") {
        navigate(
          `/operation/invoice-listing/invoice-preview/${encryptDataForURL(
            row["im_id"],
          )}/${encryptDataForURL(row["im_invoiceurl"])}/${encryptDataForURL(
            row["im_invoicenumber"],
          )}?invoice_date=${encryptDataForURL(row["im_invoice_date"])}`,
        );
      } else if (action?.label == "Edit Debit Note") {
        navigate(
          `/operation/invoice-listing/create-debit/${encryptDataForURL(
            row["im_id"],
          )}` +
          "?status=" +
          encryptDataForURL("Edit"),
        );
      } else if (action?.label == "Approve") {
        navigate(
          `/operation/invoice-listing/create-invoice/${encryptDataForURL(
            row["im_id"],
          )}` +
          "?status=" +
          encryptDataForURL("View") +
          "&isCourier=" +
          encryptDataForURL(true) +
          "&isCreditNote=" +
          encryptDataForURL(true),
        );
        setTimeout(() => {
          window.location.reload();
        }, 10);
      }
    } else if (moduleType == "jioperationjsonb") {
      if (action.status === "accepted") {
        let redirectUrl = getOperationActivityUrl(
          row["operation_type"]["operation_type_name"],
        );
        navigate(
          redirectUrl +
          encryptDataForURL(row["ji_id"]) +
          "?action=" +
          encryptDataForURL("View") +
          "&status=" +
          encryptDataForURL(action?.status) +
          "&operationMode=" +
          encryptDataForURL(row?.["operation_type"]?.operation_type_code),
        );
      } else if (action.status === "posted") {
        let redirecturl = getOperationActivityListPageUrl(
          row["operation_type"]["operation_type_code"],
        );
        redirecturl = redirecturl.replace(/\/([^\/]*)$/, "-$1");
        navigate(
          redirecturl +
          "view" +
          "/" +
          encryptDataForURL(row["ji_id"]) +
          "?action=" +
          encryptDataForURL("View") +
          "&status=" +
          encryptDataForURL(action?.status) +
          `&isFullDetails=${encryptDataForURL(1)}`,
        );
      } else {
        navigate(
          action?.redirectUrl +
          "/" +
          encryptDataForURL(row["ji_id"]) +
          "?action=" +
          encryptDataForURL("View") +
          "&status=" +
          encryptDataForURL(action?.status) +
          "&operationMode=" +
          encryptDataForURL(row?.["operation_type"]?.operation_type_code),
        );
      }
    } else if (moduleType === "TPIMain") {
      navigate(
        `/operation/vessel-ji-list/other-tpi/${encryptDataForURL(
          row["fk_jiid"],
        )}/${encryptDataForURL("otherTPI")}/${encryptDataForURL(
          row["fk_jis_id"],
        )}/${encryptDataForURL(
          row["tpi_id"],
        )}?OperationType=${encryptDataForURL(
          row["activity_code"],
        )}&operationId=${encryptDataForURL(row["fk_jis_id"])}`,
      );
    } else if (moduleType === "consortiumorder") {
      if (action?.label == "View JI") {
        navigate(
          `/operation/jrfInstructionListing?filterList=${encryptDataForURL(
            "consortium_order-" + row["co_id"],
          )}`,
        );
      } else {
        navigate(
          `/operation/consortiums-list/consortium/${encryptDataForURL(
            row["co_id"],
          )}`,
        );
      }
    } else if (moduleType === "jobCosting") {
      if (action?.label == "Comment") {
        setCurrentActiverow(row);
        setIsCustomPopup(true);
      }
      else if (action?.label === "Send for Approval") {

        const normalizedRow = {
          fk_approval_id: row?.fk_approval_id,
          client: row?.client,
          branch: row?.branch,
          fk_im_id: row?.fk_im_id,
        };
        const sourceComments = {
          ...(row?.jc_comment_json || {}),
          ...(formData?.[0]?.jc_comment_json || {})
        };
        const flattenedComments = {};
        Object.keys(sourceComments).forEach((key) => {
          flattenedComments[key] = sourceComments[key] ?? null;
        });
        const finalFormData = {
          0: {
            ...row,
            ...formData[0],
            ...flattenedComments,

            ...normalizedRow
          }
        };


        handleJobCostingFormCreateAndUpdate(
          setFormData,
          row.jc_id,
          finalFormData,
          formConfig,
          navigate,
          "sent_for_approval",
          false,
          getAllListingData
        );
      }
      else {
        navigate(`/audit/job-costing-edit/${encryptDataForURL(row["jc_id"])}`);
      }
    } else if (moduleType === "auditBranchExpenses") {
      navigate(`/audit/auditBranchExpenseForm/${encryptDataForURL(row["id"])}`);
    } else if (moduleType === "auditBranchSales") {
      navigate(`/audit/BranchSalesForm/${encryptDataForURL(row["id"])}`);
    }
    else if (moduleType === "auditOutstanding") {
      navigate(`/audit/auditOutstandingForm/${encryptDataForURL(row["id"])}`);
    } else if (moduleType === "auditSalesRegister") {
      navigate(`/audit/auditSalesRegisterForm/${encryptDataForURL(row["id"])}`);
    } else if (moduleType === "purchaseReq") {
      if (action?.label == "Edit") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}`,
        );
      } else if (action?.label == "Send for Approval") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}`,
        );
      } else if (action?.label == "Approve") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}`,
        );

        // handlePurchaseOrderCreateUpdate(
        //   row,
        //   handleSubmit,
        //   setIsOverlayLoader,
        //   navigate,
        //   3,
        //   setFormData
        // )
      } else if (action?.label == "Update") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}`,
        );
      } else if (action?.label == "PO Received") {
        // setIsSubListPopupOpen(true)
        // setSelectedItems(row.items)
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}?isProdRecv=${encryptDataForURL(true)}`,
        );
      } else if (action?.label == "Create PO") {
        setIsSubListPopupOpen(true);
        setSelectedItems(row);
      }
    } else if (moduleType === "purchase") {
      if (action?.label == "Create P.O") {
        // navigate(`/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}`);
        setIsSubListPopupOpen(true);
        setSelectedItems(row);
      } else if (action?.label == "Edit") {
        navigate(`/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}`);
      } else if (action?.label == "Update") {
        navigate(`/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}`);
      } else if (action?.label == "Download") {
        handleDownloadPO(row["po_id"], row["po_number"]);
      } else if (action?.label == "Approve") {
        // handleDownloadPO(row["po_id"])
        navigate(
          `/purchase/purchaseForm/${encryptDataForURL(
            row["po_id"],
          )}?status=${encryptDataForURL("View")}&action=${encryptDataForURL("approve")}`,
        );
      } else if (action?.label == "PO Received") {
        // navigate(`/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
        //   row["req_no"])}?isProdRecv=${encryptDataForURL(true)}`);
        navigate(
          `/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}?status=${encryptDataForURL("View")}` +
          "&isProdRecv=" +
          encryptDataForURL(true),
        );
      }
    } else if (moduleType === "supplier") {
      if (action?.label == "Edit") {
        navigate(
          `/supplierList/supplierForm/${encryptDataForURL(row["sup_id"])} `,
        );
      }
    } else if (moduleType === "purchaseItems") {
      if (action?.label == "Edit") {
        navigate(
          `/itemlist/item/${encryptDataForURL(row["item_id"])}?action=${encryptDataForURL("Change")}`,
        );
      }
    } else if (moduleType === "departmentmasterList") {
      if (action?.label == "Edit") {
        navigate(
          `/departmentForm/${encryptDataForURL(row["dept_id"])}?action=${encryptDataForURL("Change")}`,
        );
      }
    } else if (moduleType === "branchmasterList") {
      if (action?.label == "Edit") {
        navigate(
          `/branchForm/${encryptDataForURL(row["br_id"])}?action=${encryptDataForURL("Change")}`,
        );
      }
    } else if (moduleType === "category") {
      if (action?.label == "Edit") {
        navigate(
          `/categorylist/categoryForm/${encryptDataForURL(row["category_id"])}?action=${encryptDataForURL("Change")}`,
        );
      }
    } else if (moduleType === "calibration") {
      if (action?.label == "Edit") {
        navigate(
          `/calibrationList/calibrationForm/${encryptDataForURL(
            row["calib_id"],
          )} `,
        );
      }
    } else if (moduleType === "amc") {
      if (action?.label == "Edit") {
        navigate(`/AMCList/AMCForm/${encryptDataForURL(row["amc_id"])} `);
      }
    }
    else if (moduleType === "tranferstocks") {
      if (action?.label == "Edit") {
        navigate(`/transfer-stocks/form/${encryptDataForURL(row["st_transfer_id"])} `);
      }
    }
    else if (moduleType === "stocks") {
      if (action?.label == "Edit") {
        navigate(
          `/chemicalStocks/chemicalStocksForm/${encryptDataForURL(
            row["chemist_stock_id"],
          )}`,
        );
      }
    } else if (moduleType === "incentives") {
      if (action?.label == "Edit") {
        navigate(
          `/incentivesList/incentivesForm/${encryptDataForURL(
            row["incentive_id"],
          )}`,
        );
      }
    } else if (moduleType === "creditNoteModule") {
      if (["Update", "Edit"].includes(action?.label)) {
        navigate(
          `/collections/credit-notes/credit-form/${encryptDataForURL(
            row["cn_id"],
          )}`,
        );
      }
    } else if (moduleType === "OnAccountDetails") {
      if (action?.label == "Edit") {
        navigate(
          `/collections/on-accounts/${encryptDataForURL(row["ioa_id"])}` +
          "?action=" +
          encryptDataForURL("Edit"),
        );
      }
    } else {
      if (action?.status == "testReport") {
        // navigate(
        //   action?.redirectUrl +
        //   "/" +
        //   encryptDataForURL(row["internal_certificate_id"])
        // );
        navigate(
          `/testReport/previewPDF/${encryptDataForURL(row["internal_certificate_id"])}` +
          "?ReferenceNo=" +
          encryptDataForURL(row?.jrf_referenceno),
        );
        // handleTestReport(row, action);
      } else {
        if (row["jrf_status"] === "saved") {
          if (row["jrf_is_ops"]) {
            navigate(
              "/jrfListing/operation-jrf?status=" +
              encryptDataForURL("Edit") +
              "&id=" +
              encryptDataForURL(jrf_id),
            );
          } else {
            if (row["jrf_is_external"]) {
              navigate(
                "/jrfListing/external-jrf?status=" +
                encryptDataForURL("Edit") +
                "&id=" +
                encryptDataForURL(jrf_id),
              );
            } else {
              navigate(
                "/jrfListing/jrf?status=" +
                encryptDataForURL("Edit") +
                "&id=" +
                encryptDataForURL(jrf_id),
              );
            }
          }
        } else if (row["jrf_is_ops"] && row["jrf_status"] === "posted") {
          navigate(
            "/jrfListing/operation-inwardForm-checklist?status=" +
            encryptDataForURL("checklist") +
            "&id=" +
            encryptDataForURL(jrf_id),
          );
        } else if (
          user?.role === "LR" &&
          status === "rejected" &&
          row["jrf_is_external"]
        ) {
          navigate(
            "/jrfListing/external-jrf?status=" +
            encryptDataForURL(action?.status) +
            "&id=" +
            encryptDataForURL(jrf_id),
          );
        } else if (status === "rejected" && row["jrf_is_ops"]) {
          navigate(
            "/jrfListing/operation-jrf?status=" +
            encryptDataForURL(action?.status) +
            "&id=" +
            encryptDataForURL(jrf_id),
          );
        } else {
          navigate(
            action?.redirectUrl +
            "?status=" +
            encryptDataForURL(action?.status) +
            "&id=" +
            encryptDataForURL(jrf_id),
          );
        }
      }
    }
  };

  const handleRegenrateFunc = async (endPoint, payload, fieldType) => {
    try {
      setIsOverlayLoader(true);
      payload.is_regenerate = true;
      let res = await postDataFromApi(endPoint, payload);
      getAllListingData();
      // setResponse(prev => ({
      //   ...prev,
      //   data: prev.data.map((item, index) =>
      //     index === rowIndex
      //       ? { ...item, [fieldType]: false }
      //       : item
      //   )
      // }));
      toast.success("Successfully Re-Generated", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsOverlayLoader(false);
    }
  };
  const checkRoleBseCondition = (buttonDetails) => {
    if (user?.role === "SU" && buttonDetails.isRegenerateBtn) {
      switch (moduleType) {
        case "internalcertificate":
          if (!row.ic_is_updated_by_su) {
            return false;
          }
          break;
        case "sfm":
          if (!row.sfm_is_updated_by_su) {
            return false;
          }
          break;
        case "testmemomain":
          if (!row.tm_is_updated_by_su) {
            return false;
          }
          break;
        case "jrf":
          if (!row.jrf_is_updated_by_su) {
            return false;
          }
          break;
        default:
          break;
      }
    } else if (moduleType === "jrf") {
      if (user?.role === "LR" && status === "rejected") {
        if (!row["jrf_is_external"] && !row["jrf_is_regular"]) {
          return false;
        } else if (!row["jrf_is_external"]) {
          return false;
        }
      }
      else {
        if (row.jrf_is_request_for_cancel) {
          return false;
        }
      }
    } else if (moduleType === "allotment") {
      if (user?.role === "DTM") {
        if (user?.logged_in_user_info?.usr_id !== row["sa_sampleallottedto"]) {
          return false;
        }
      } else if (user?.role === "LC") {
        if (GetTenantDetails(1, 1) === "TPBPL") {
          return false;
        }
      }
    } else if (["jobinstruction", "jioperationjsonb"].includes(moduleType)) {
      // if (user?.role === "BU") {
      //   if (user?.logged_in_user_info?.usr_id !== row['fk_useropsexecutiveid']) {
      //     return false
      //   }
      // }
    } else if (moduleType === "jobCosting") {
      if (['SU'].includes(user?.role)) {
        return false;
      }
      if (
        ["cancelled"].includes(buttonDetails.btnshortName) &&
        row?.fk_im_id?.im_is_jc_comment
      ) {
        return false;
      }
      // else if (
      //   ["sent_for_approval"].includes(buttonDetails.btnshortName) &&
      //   row?.fk_approval_id?.usr_id !== user?.logged_in_user_info?.usr_id
      // ) {
      //   return false;
      // }
    } else if (moduleType === "purchase") {
      if ((['AUDIT'].includes(user?.role) && row.created_by !== user?.logged_in_user_info?.usr_id)) {
        return false;
      }
      if (
        ["Saved", "Reject"].includes(buttonDetails.btnshortName) &&
        row?.created_by != user?.logged_in_user_info?.usr_id
      ) {
        return false;
      } else if (
        ["posted"].includes(buttonDetails.btnshortName) &&
        row?.fk_approval_id != user?.logged_in_user_info?.usr_id
      ) {
        return false;
      } else if (
        ["Approved"].includes(buttonDetails.btnshortName) &&
        (row?.requisition_details?.req_recieved_all_items ||
          ["Pending"].includes(row?.po_vendor_status))
      ) {
        return false;
      } else if (
        ["Received"].includes(buttonDetails.btnshortName) &&
        !["PM", "PE"].includes(user?.role)
      ) {
        return false;
      }
    } else if (moduleType === "purchaseReq") {
      if (((['AUDIT'].includes(user?.role) && ![SagarAuditUserRole()].includes(user?.all_roles?.usr_emp_id_orig)) && row.created_by !== user?.logged_in_user_info?.usr_id)) {
        return false;
      }
      if (
        ["saved", "reject"].includes(buttonDetails.btnshortName) &&
        row?.req_created_by != user?.logged_in_user_info?.usr_id
      ) {
        return false;
      } else if (
        ["sent for approval"].includes(buttonDetails.btnshortName) &&
        row?.req_fk_approval_id !== user?.logged_in_user_info?.usr_id
      ) {
        return false;
      } else if (["approved"].includes(buttonDetails.btnshortName)) {
        if (row?.req_recieved_all_items) {
          return false;
        }
      }
    } else if (
      ["supplier", "stocks", "calibration", "purchaseItems"].includes(
        moduleType,
      )
    ) {
      if (
        ["saved", "posted"].includes(buttonDetails.btnshortName) &&
        !getPurchaseManager(moduleType, "change")
      ) {
        return false;
      }
    } else if (["invoice"].includes(moduleType)) {
      if (row.im_is_credit_created) {
        if (["view invoice"].includes(buttonDetails.label.toLowerCase())) {
          return ["BU", "LR"].includes(user?.role);
        } else {
          if (["approve"].includes(buttonDetails.label.toLowerCase())) {
            if (["CU"].includes(getCurrentRole())) {
              return (
                ["CU"].includes(
                  row?.im_credit_note_json?.im_credit_next_approval,
                ) && ["CreditNoteList"].includes(subModuleType)
              );
            } else {
              return [getUserDetails()?.all_roles?.usr_emp_id_orig].includes(
                row?.im_credit_note_json?.im_credit_next_approval,
              );
            }
          }
        }
      } else {
        if (["approve"].includes(buttonDetails.label.toLowerCase())) {
          return false;
        }
      }
    }
    if (["jrf", "sampleinward"].includes(moduleType)) {
      if (
        ["testmemoresult", "testReport"].includes(buttonDetails.btnshortName) &&
        !row["internal_certificate_id"]
      ) {
        return false;
      }
    }
    return true;
  };
  const chkBtnExists = (action) => {
    const validConditions = user?.role ? getBtnListArray() : [];
    const filterData = validConditions?.filter((condition) => {
      if (!checkRoleBseCondition(condition)) {
        return false;
      } else if (action.isDupplicate) {
        if (moduleType === "purchaseReq") {
          if (["Create PO"].includes(action.label)) {
            if (row?.hide_create_po_button || !["PM", "PE"].includes(user?.role)) {
              return false;
            }
          } else if (
            ["PO Received"].includes(action.label)

          ) {
            if ((['AUDIT'].includes(user?.role) && row.created_by !== user?.logged_in_user_info?.usr_id)) {
              return false;
            }
            if (!row?.hide_create_po_button) {
              return false;
            }
          }
        } else if (moduleType === "creditnoteModule") {
          if (["rejected"].includes(action?.status)) {
            return checkNextApproval() == row.cn_next_approval_role;
          }
        }
        else if (moduleType === "purchase") {
          if ((['AUDIT'].includes(user?.role) && row.created_by !== user?.logged_in_user_info?.usr_id)) {
            return false;
          }
          if (["PO Received"].includes(action.label)) {
            if ((row?.requisition_details?.req_recieved_all_items ||
              ["Pending"].includes(row?.po_vendor_status))) {
              return false;
            }
          }
        }
        return (
          condition.btnStatus.toLowerCase() === status.toLowerCase() &&
          condition.btnshortName.toLowerCase() === action?.status.toLowerCase()
        );
      } else {
        if (user?.role === "SU" && condition.isRegenerateBtn) {
          if (['jrf'].includes(moduleType)) {
            return (
              (condition.btnStatus.toLowerCase() === status.toLowerCase() ||
                !["posted", "saved"].includes(
                  status.toLowerCase(),
                )) &&
              condition.label.toLowerCase() === action?.label.toLowerCase()
            );
          }
          return (
            (condition.btnStatus.toLowerCase() === status.toLowerCase() ||
              ["verified", "results", "certified", "completed"].includes(
                status.toLowerCase(),
              )) &&
            condition.label.toLowerCase() === action?.label.toLowerCase()
          );
        }
        return (
          condition.btnStatus.toLowerCase() === status.toLowerCase() &&
          condition.label.toLowerCase() === action?.label.toLowerCase()
        );
      }
    });
    return Boolean(filterData?.length > 0);
  };
  const buttons = actions.map((action, actionIndex) => {
    let isValid;
    isValid = status && chkBtnExists(action);
    if (["OnAccountDetails"].includes(moduleType)) {
      isValid = !row?.ioa_is_closed && !['CCPA'].includes(user?.role);
    }
    if (!isValid || action?.type === "icon") {
      return null;
    }
    if (["jobinstruction", "jioperationjsonb"].includes(moduleType)) {
      if (user?.role === "BU") {
        if (
          user?.logged_in_user_info?.usr_id !== row["fk_useropsexecutiveid"] &&
          !row["fk_useropsexecutives"].includes(
            user?.logged_in_user_info?.usr_id,
          )
        ) {
          return row["status"] === "accepted" ? (
            <button
              type="button"
              key={"listing-action" + actionIndex}
              className="iconBtn"
              onClick={() => handleOnclick(action)}
            >
              View
            </button>
          ) : null;
        }
      }
    }
    if (["invoice"].includes(moduleType)) {
      // if (row["im_is_debit_created"] && row["im_status"] === "debit_save") {
      //   return null;
      // }
    }
    return (
      <button
        type="button"
        key={"listing-action" + actionIndex}
        className="iconBtn"
        onClick={() => handleOnclick(action)}
      >
        {action?.label}
      </button>
    );
  });
  return (
    <>
      {buttons}
      <ConfirmationModal
        isOpen={isShowMessagePopup}
        handleClose={() => {
          setIsShowMessagePopup(false)
          setShowMessageDescription(null)
        }}
        handleConfirm={() => {
          setIsShowMessagePopup(false)
          setShowMessageDescription(null)
        }}
        popupMessage={showMessageDescription || formConfig.listView?.popuModalData?.message}
        popupHeading={formConfig.listView?.popuModalData?.title}
        popbuttons={{
          yes: "Close",
        }}
        isNoOption={true}
        width="lg"
      />
      <RejectPopupModal
        isOpen={isCancelRemarkOpen}
        handleClose={() => {
          setIsCancelRemarkOpen(false);
          setCancelRemark("");
          setCancelSaId(null);
        }}
        handleConfirm={() => handleAllotmentCancel(cancelSaId, cancelRemark)}
        popupMessage="Are you sure you want to cancel this allotment?"
        popupHeading="Cancel Allotment"
        setRemarkText={setCancelRemark}
        remarkText={cancelRemark}
        isCancelPopupOpen={true}
      />
    </>
  );
};

export default ListingActionButton;
